
import { isEmpty } from 'lodash';
import AdsApi from '../../libs/ads-request/ads-api';
import AStepper from '../../components/AStepper.vue';
import EventBus from '../../events';

export default {
  name: 'MyStatus',
  components: {
    AStepper,
  },
  props: {
    isExpandedCard: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    expand: true,
    step: 0,
    lastDate: '--',
    dataStepper: [],
    promiseDate: null,
    promiseHour: null,
    orderQuotationCreated: null,
    orderPayment: null,
    orderStartWork: null,
    iconBeforeActive: {
      name: 'check',
    },
    iconActive: {
      name: 'car',
      type: '',
    },
    iconAfterActive: { name: 'reload', class: '' },
    iconInactive: { name: 'timestop' },
    showView: false,
    loaderError: false,
    loaderMessage: 'Cargando estatus ...',
  }),
  computed: {
    receptionHour() {
      return this.dataStepper[0].subtitle !== '--'
        ? this.moment(this.dataStepper[0].subtitle, 'DD/MM/YYYY HH:mm').format('HH:mm')
        : '--';
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    isThemeCupra() {
      return this.$session.get('brand') === 'cupra';
    },
  },
  watch: {
    isExpandedCard(val) {
      this.expand = val;
    },
  },
  mounted() {
    this.iconActive.type = this.isThemeDefault ? 's' : '';
    this.iconAfterActive.class = !this.isThemeAudi ? 'bx-spin' : 'rotate-left';
    this.initialCharge();
  },
  methods: {
    isEmpty,
    getOrderStatus() {
      return AdsApi.getOrderStatus()
        .then(async (response) => {
          if (response.data.length > 0) {
            const { data } = response;

            const ordersDeliver = data.every(
              (item) => item.orderEstatus === 118
              || item.orderEstatus === 113
              || item.orderEstatus === 119,
            );
            const ordersFinish = data.every((item) => item.orderEstatus === 113);

            data.forEach((element) => {
              this.orderStatusRemap(element);
            });

            this.promiseDate = this.moment(this.promiseDate).utc().format('DD/MM/YYYY');
            this.promiseHour = this.moment(this.promiseHour).format('HH:mm');
            data[0].orderStartWork = this.orderStartWork;
            data[0].orderQuotationCreated = this.orderQuotationCreated;
            data[0].orderPayment = this.orderPayment;
            data[0].delivery = ordersDeliver;
            data[0].ordersFinished = ordersFinish;
            this.insertStatus(data[0]);
          }
          EventBus.$emit('validateViews');
          this.showView = true;
        })
        .catch(() => {
          this.loaderError = true;
        });
    },
    orderStatusRemap(element) {
      if (element.orderEstatus === 121) return;

      if (this.promiseDate == null) {
        this.promiseDate = element.orderPromiseDate;
        this.promiseHour = `${this.moment().format('YYYY-MM-DD')} ${element.orderPromiseHour}`;
      }

      if (element.orderPromiseDate != null
                && this.moment(element.orderPromiseDate).isAfter(this.moment(this.promiseDate))) {
        this.promiseDate = element.orderPromiseDate;
        this.promiseHour = `${this.moment().format('YYYY-MM-DD')} ${element.orderPromiseHour}`;
      }

      if (this.orderStartWork == null) {
        this.orderStartWork = element.orderStartWork;
        this.orderQuotationCreated = element.orderQuotationCreated;
      }

      if (element.orderStartWork != null
              && (this.moment(this.orderStartWork).isBefore(this.moment(element.orderStartWork))
                && element.orderStartWork !== null && element.orderQuotationCreated !== null)) {
        this.orderStartWork = element.orderStartWork;
        this.orderQuotationCreated = element.orderQuotationCreated;
      }

      if (this.orderPayment == null && element.orderPayment != null) {
        this.orderPayment = element.orderPayment;
      }

      if (element.orderPayment != null
              && this.moment(this.orderPayment).isBefore(element.orderPayment)) {
        this.orderPayment = element.orderPayment;
      }
    },
    async initialCharge() {
      try {
        await this.getOrderStatus();

        if (!this.$session.get('showAdditionalBudgets')) {
          let show = false;
          await AdsApi.getAdditionalActivities(this.$session.get('orderId'))
            .then((data) => {
              if (data && data.length) show = true;
            })
            .catch((error) => {
              throw new Error(`${error}`);
            });
          if (!show) {
            await AdsApi.getUnbudgetedActivities()
              .then((data) => {
                if (data && data.length) show = true;
              })
              .catch((error) => {
                throw new Error(`${error}`);
              });
          }
          this.$session.set('showActivitiesList', show);
        }
      } catch (error) {
        throw new Error(`${error}`);
      }
    },
    insertStatus(data) {
      let step = 1;

      this.$session.set('showPreInvoice', false);
      this.$session.set('showAdditionalBudgets', false);
      this.$session.set('showActivitiesList', true);

      this.dataStepper.push(
        {
          title: '¡Recibimos tu vehículo!',
          subtitle: this.loadDate(data.orderReceptionDate, step),
        },
        {
          title: 'Tu vehículo está en servicio',
          subtitle: this.loadDate(data.orderStartWork, step += 1),
        },
      );

      if (!isEmpty(data.orderQuotationCreated)) {
        this.$session.set('showAdditionalBudgets', true);
        this.$session.set('showActivitiesList', false);
        this.$session.set('effectiveDate', data.orderQuotationCreated);
        this.dataStepper.push({
          title: 'Tu vehículo tiene reparaciones adicionales',
          subtitle: this.loadDate(data.orderQuotationCreated, step += 1),
          event: data.orderEndWork == null,
        });
      }

      if (data.showPayment) {
        this.$session.set('showAdditionalBudgets', false);
        this.$session.set('showActivitiesList', true);
        this.$session.set('showPreInvoice', true);
      }

      if (this.$session.get('orderStatus') === 'CERRADA' && !isEmpty(data.orderDelivery)) { this.$session.set('showPreInvoice', false); }

      this.dataStepper.push(
        {
          title: 'Tu vehículo está listo, ya puedes realizar tu pago',
          subtitle: this.loadDate(data.delivery ? data.orderPayment : null, step += 1),
        },
        {
          title: '¡Gracias!',
          subtitle: this.loadDate(data.ordersFinished ? data.orderDelivery : null, step += 1),
        },
      );
    },
    loadDate(date, step) {
      const FORMAT_DATE = 'DD/MM/YYYY HH:mm';

      let dateFormatting = '--';

      if (!isEmpty(date)) {
        this.step = step;
        dateFormatting = this.moment(date).utc().format(FORMAT_DATE);
        this.lastDate = this.moment(date).utc().format('DD [de] MMMM [de] YYYY');
      }

      return dateFormatting;
    },
    redirectToReception() {
      this.$router.push({ name: 'reception' });
    },
  },
};
